import React from "react";

const Card05 = ({item}) => {
    return (
        <div className="card05-wrapper">
            <div className="card05-image">
                <img src={item.image} alt={item.title} />
            </div>
            <div className="card05-detail">
                <div className="card05-date">
                    {item.date}
                </div>
                <div className="card05-title font-face-pop">
                    {item.title}
                </div>
                <div className="card05-description">
                    {item.content}
                </div>
            </div>
        </div>
    )
}

export default Card05;